import {
  EVENTLIST_FETCHITEMS_LOAD,
  EVENTLIST_FETCHITEMS_SUCCEED,
  EVENTLIST_FETCHITEMS_FAIL,
  EVENTLIST_CHANGETABLE_CHANGE,
  EVENTLIST_SEARCHTABLE_EDIT,
  EVENTLIST_SEARCHTABLE_SEARCH,
} from '../constants/actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case EVENTLIST_FETCHITEMS_LOAD:
      return { ...state, isFetchItemsLoading: true, fetchItemsError: null }
    case EVENTLIST_FETCHITEMS_SUCCEED:
      return {
        ...state,
        isFetchItemsLoading: false,
        items: action.items,
        pagination: { ...state.pagination, total: action.total },
      }
    case EVENTLIST_FETCHITEMS_FAIL:
      return {
        ...state,
        isFetchItemsLoading: false,
        items: null,
        fetchItemsError: action.fetchItemsError,
      }
    case EVENTLIST_CHANGETABLE_CHANGE: {
      return {
        ...state,
        pagination: action.pagination,
        filters: action.filters,
        sorter: action.sorter,
      }
    }
    case EVENTLIST_SEARCHTABLE_EDIT:
      return {
        ...state,
        search: action.search,
      }
    case EVENTLIST_SEARCHTABLE_SEARCH:
      return {
        ...state,
        isSearching: action.isSearching,
      }
    default:
      return state
  }
}
